// extracted by mini-css-extract-plugin
module.exports = {"body":"ISO_body__MNf9V","image":"ISO_image__3kP0W","title":"ISO_title__ZjfsK","text":"ISO_text__2bKgh"};